import React from 'react';
import useSubjectsContext from './context';
import RawHTML from '~/components/jsx-helpers/raw-html';
import useOptimizedImage from '~/helpers/use-optimized-image';
import './tutor-ad.scss';
export function TutorAdThatTakesData({ heading, image, adHtml, linkHref, linkText }) {
    const optimizedImage = useOptimizedImage(image === null || image === void 0 ? void 0 : image.file, 400);
    return (React.createElement("section", { className: "tutor-ad" },
        React.createElement("div", { className: "content" },
            React.createElement("h2", null, heading),
            React.createElement("img", { role: "presentation", src: optimizedImage }),
            React.createElement(RawHTML, { html: adHtml }),
            React.createElement("a", { "data-analytics-link": true, className: "btn primary", href: linkHref }, linkText))));
}
export default function TutorAd() {
    const { tutorAd } = useSubjectsContext();
    const { image, heading, adHtml, linkHref, linkText } = tutorAd[0].value;
    return (React.createElement(TutorAdThatTakesData, { heading, image, adHtml, linkHref, linkText }));
}
